<template>
  <div>
    <section>
      <Carousel></Carousel>
    </section>

    <section>
      <v-container>
      <v-row
        :class="{'my-12': $vuetify.breakpoint.mdAndUp, 'flex-column': $vuetify.breakpoint.smAndDown}"
        align="center"
        justify="space-around"
      >

        <v-col cols="12" lg="4" md="4" sm="12" v-if="searchPermission">
          <div class="text-center">
            <div class="py-3">
              <v-icon x-large color="blue darken-1">fas fa-search</v-icon>
            </div>
            <h3 class="py-4">
              Search Deliveries
            </h3>
            <p class="py-4">
              Look for your deliveries, track them and request modifications.
            </p>
            <v-btn outlined color="blue darken-1" to="/search">
              To the search page
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" lg="4" md="4" sm="12" v-if="manifestPermission">
          <div class="text-center">
            <div class="py-3">
              <v-icon x-large color="blue darken-1">fas fa-upload</v-icon>
            </div>
            <h3 class="py-4">
              Manage Manifests
            </h3>
            <p class="py-7">
              View and upload your manifests.
            </p>
            <v-btn outlined color="blue darken-1" to="/manifest">
              To the manifest page
            </v-btn>
          </div>
        </v-col>

        <v-col cols="12" lg="4" md="4" sm="12" v-if="searchPermission">
          <div class="text-center">
            <div class="py-3">
              <v-icon x-large color="blue darken-1">fas fa-exclamation-triangle</v-icon>
            </div>
            <h3 class="py-4">
              Manage Exceptions
            </h3>
            <p class="py-4">
              Manage your rescheduled, cancelled and on-hold deliveries.
            </p>
            <v-btn outlined color="blue darken-1" to="/exceptions">
              To the exceptions page
            </v-btn>
          </div>
        </v-col>


       </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
    import Carousel from "./util/Home/Carousel";

    export default {
        name: "HomePage",
        components: {Carousel},
        computed: {
            searchPermission() {
                return this.$store.getters['auth/hasPermission']('delivery_view');
            },
            manifestPermission() {
                return this.$store.getters['auth/hasPermission']('manifest_view');
            },
        }
    }
</script>

<style scoped>
  .center {
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue